import { deleteEvaluator, patchEvaluation, saveEvaluator } from 'api/interview'

// NOTE: hook that gathers all the data mutation handlers
// which call api with methods like POST, PATCH, PUT, DELETE
// and exposes them for local hooks
export const useMutations = () => {
  const handleDeleteEvaluator = async ({ uuid }) =>
    await deleteEvaluator({ uuid })

  const handlePostEvaluator = async ({ email, jobInterview, name }) =>
    await saveEvaluator({ email, jobInterview, name })

  const handlePatchEvaluation = async ({ evaluationData, id, status }) =>
    await patchEvaluation({ evaluationData, id, status })

  return {
    handleDeleteEvaluator,
    handlePatchEvaluation,
    handlePostEvaluator,
  }
}
